import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getActiveReactPage } from '../../../../r/shared/utils';
import Button from '../../../../r/components/shared/button';
import { setIsMissingDependency } from '../reducers';
import { files } from '../../../../r/libs/assets';
import {
  coreDependenciesAreLoaded,
  isRecaptchaSDKLoaded,
  isGoogleSDKLoaded,
  loadReCaptchaSDK,
  signInWithGoogle,
  loadGoogleSDK
} from '../slices';

const getPageData = (onClickAlternatePage, page) => {
  const pageData = {
    ResetPassword: {
      alternatePageText: <>Want to sign in instead? <span onClick={onClickAlternatePage}>Sign in here</span></>,
      googleButtonText: 'Sign Up with Google',
      defaultButtonText: 'Reset Password'
    },
    Confirm2FA: {
      alternatePageText: <>Want to sign in instead? <span onClick={onClickAlternatePage}>Sign in here</span></>,
      googleButtonText: 'Sign Up with Google',
      defaultButtonText: 'Sign In'
    },
    SignUp: {
      alternatePageText: <>Already have an account? <span onClick={onClickAlternatePage}>Sign in here</span></>,
      googleButtonText: 'Sign Up with Google',
      defaultButtonText: 'Sign Up with Email'
    },
    SignIn: {
      alternatePageText: <>New to Formplus? <span onClick={onClickAlternatePage}>Sign up here</span></>,
      googleButtonText: 'Sign In with Google',
      defaultButtonText: 'Log In'
    }
  };

  return pageData[page];
};

const FormFooter = () => {
  const { isMissingDependency, feedback } = useSelector((state) => state.auth);
  const disableAuth = feedback.isLoading || isMissingDependency;
  const [authType, setAuthType] = useState('credentials');
  const { name } = getActiveReactPage();
  const dispatch = useDispatch();
  const history = useHistory();

  const reloadPage = () => location.reload();

  const getButtonText = (buttonType) => {
    const activeAuthType = {
      defaultButtonText: 'credentials',
      googleButtonText: 'google'
    }[buttonType];
    
    if (feedback.action && activeAuthType === authType) return feedback.action;
    return pageData[buttonType];
  };

  const alternatePageHandler = () => {
    if (name === 'SignIn') return history.push('/auth/sign-up');
    return history.push('/auth');
  };

  const handleGoogleSignIn = () => {
    if (!coreDependenciesAreLoaded()) return dispatch(setIsMissingDependency(true));
    dispatch(signInWithGoogle());
    setAuthType('google');
  };

  const pageData = getPageData(
    alternatePageHandler, name
  );

  if (!pageData) return null;

  useEffect(() => {
    // Silently attempt to load the Google reCaptcha SDK if not loaded.
    if (!isRecaptchaSDKLoaded()) loadReCaptchaSDK();

    // Silently attempt to load the Google auth SDK if not loaded.
    if (!isGoogleSDKLoaded()) loadGoogleSDK();
  }, []);

  return (
    <div className="footer">
      <Button
        loading={authType === 'credentials' && feedback.isLoading}
        text={getButtonText('defaultButtonText')}
        disabled={disableAuth}
        icon={files.mail}
        variant="filled"
        type="submit"
        block
      />

      <span className="separator">OR</span>

      {isMissingDependency && (
        <p className="feedback warning">
          Oops! Something went wrong. Please <a onClick={reloadPage}>reload</a> page and try again.
        </p>
      )}

      <Button
        loading={authType === 'google' && feedback.isLoading}
        text={getButtonText('googleButtonText')}
        onClick={handleGoogleSignIn}
        icon={files.googleIcon}
        disabled={disableAuth}
        className="google-btn"
        block
      />
      
      <p className="alternate-page">
        {pageData.alternatePageText}
      </p>
    </div>
  );
};

export default FormFooter;